class CartAccordion extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.noLocationStored) {
      return this.hideMessages(
        window.localStorage.getItem(this.userLocationName),
      )
    }

    window.BAO.Utils.fetchJSON(`/browsing_context_suggestions.json`, {
      method: 'GET',
    }).then(res => {
      this.hideMessages(res.detected_values.country.handle)
    })
  }

  hideMessages (userLocation) {
    this.els.item.elements.forEach(el => {
      const type = el.dataset.type
      if (type === 'Global') return

      const countries = el.dataset.countries.split(',')
      if (type === 'Specific countries' && !countries.includes(userLocation)) {
        el.remove()
      }
      if (type === 'Rest of world' && countries.includes(userLocation)) {
        el.remove()
      }
    })

    const itemEls = this.querySelectorAll('[data-cart-accordion-el="item"]')

    if (itemEls.length === 0) return

    this.setAttribute('aria-hidden', 'false')
  }

  get noLocationStored () {
    return (
      window.localStorage.getItem(this.userLocationName) == null ||
      (window.localStorage.getItem(this.userLocationName) === undefined &&
        !Shopify.designMode)
    )
  }

  get userLocationName () {
    return `BAO-location-portrait`
  }
}

if (!customElements.get('cart-accordion')) {
  customElements.define('cart-accordion', CartAccordion)
}
